import React, { useState } from 'react';

interface ProjectSidebarProps {
  projects: { id: string; name: string; sessions: any[] }[];
  activeProjectId: string | null;
  onProjectChange: (id: string) => void;
  onCreateProject: (name: string) => void;
}

const ProjectSidebar: React.FC<ProjectSidebarProps> = ({ 
  projects, 
  activeProjectId, 
  onProjectChange, 
  onCreateProject 
}) => {
  const [showNewProjectInput, setShowNewProjectInput] = useState(false);
  const [newProjectName, setNewProjectName] = useState('');

  const handleCreateProject = () => {
    if (newProjectName.trim()) {
      onCreateProject(newProjectName.trim());
      setNewProjectName('');
      setShowNewProjectInput(false);
    }
  };

  return (
    <div className="w-64 bg-white border-r border-gray-200 min-h-screen flex flex-col shadow-sm">
      <div className="p-4 border-b border-gray-200 bg-indigo-50">
        <h2 className="text-xl font-semibold text-indigo-700">Writing Flow</h2>
      </div>
      
      <div className="p-4">
        <button 
          onClick={() => setShowNewProjectInput(true)}
          className="flex items-center gap-2 text-indigo-600 hover:text-indigo-700 text-lg font-medium py-2 px-3 rounded-full hover:bg-indigo-50 transition-colors w-full"
        >
          <span className="text-xl">+</span> New Project
        </button>
      </div>
      
      <div className="p-4 border-b border-gray-200">
        <h3 className="text-sm uppercase tracking-wider text-gray-500 font-medium">Projects</h3>
      </div>
      
      <div className="p-4 flex-1 overflow-auto">
        <h3 className="text-sm uppercase tracking-wider text-gray-500 font-medium mb-2">Recently Used</h3>
        <div className="space-y-1">
          {projects.map(project => (
            <div
              key={project.id}
              onClick={() => onProjectChange(project.id)}
              className={`py-2 px-3 text-sm rounded-md cursor-pointer flex items-center justify-between project-item ${
                activeProjectId === project.id ? 'active bg-indigo-50' : 'hover:bg-gray-100'
              }`}
            >
              <span className="truncate">{project.name}</span>
              {activeProjectId === project.id && (
                <span className="ml-2 h-2 w-2 bg-indigo-500 rounded-full"></span>
              )}
            </div>
          ))}
        </div>
      </div>

      {showNewProjectInput && (
        <div className="p-4 border-t border-gray-200 bg-gray-50">
          <div className="mb-2">
            <input
              type="text"
              value={newProjectName}
              onChange={(e) => setNewProjectName(e.target.value)}
              placeholder="Project name"
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              autoFocus
            />
          </div>
          <div className="flex space-x-2">
            <button
              onClick={handleCreateProject}
              className="px-3 py-1 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Create
            </button>
            <button
              onClick={() => {
                setShowNewProjectInput(false);
                setNewProjectName('');
              }}
              className="px-3 py-1 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectSidebar; 